/**
 * USE-OPEN-HELP-SECTION.UTILS
 * Opens the guide of the page on one of its sections ; the old help of the zone is the fallback when the guide is not there
 * (section not published, application not in French, report)
 */
import { useContext } from "react"
import { HelpGuideContext } from "@/components/help-guide.context"
import { hasHelpSection } from "@/utils/help-article.utils"

export function useOpenHelpSection(): (section: string, fallback: () => void) => void {
  const guide = useContext(HelpGuideContext)

  return (section, fallback) => {
    if (guide.isAvailable && hasHelpSection(guide.article, section)) guide.open(section)
    else fallback()
  }
}
